import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Outlet} from '@github-ui/react-router'

import {CommitsLayoutPayloadContext} from '../hooks/use-commits-layout-payload'
import {commitsLayoutRoute} from './commits-layout-route'

export function CommitsLayout() {
  const {data} = useRouteQuery(commitsLayoutRoute, 'mainQuery')

  return (
    <CommitsLayoutPayloadContext value={data}>
      <Outlet />
    </CommitsLayoutPayloadContext>
  )
}
